export class PeriodoReporteI{
    id : BigInteger;
    tipoPeriodicidad : string;
    anio : string;
    salarioMinimo : number;
    consecutivoPeriodo : string;
    descripcionPeriodo : string;
    fechaInicioPeriodo : string;
    fechaFinPeriodo : string;
    fechaInicioProcesamiento : string;
    fechaFinProcesamiento : string;
    fechaInicioRecoleccion : string;
    fechaFinRecoleccion : string;
    fechaInicioRecoleccionSuper : string;
    fechaFinRecoleccionSuper : string;
}